export default __webpack_public_path__ + "static/SRUS S190 - Especification Del Producto y Datos Técnicos-9034c5d0e203b341768b4ad1e432665c.pdf";